// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBFlAzvi6pqyIu1GKpbRh6xrqtZyhL6xp4",
  authDomain: "vitauserpauth.firebaseapp.com",
  projectId: "vitauserpauth",
  storageBucket: "vitauserpauth.appspot.com",
  messagingSenderId: "17521778669",
  appId: "1:17521778669:web:7b9e7eb60ced3e6de151e4",
  measurementId: "G-4WDSFF7RZ2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);